<template>
  <div class="xc-page xc-page-sandwich">
    <!-- 分栏布局 -->
    <div class="xc-page-main">
      <!-- 面包屑 -->
      <div class="xc-breadcrumb">
        <router-link :to="adminPath + '/program'">节目管理</router-link>
        <a>节目列表</a>
      </div>

      <div class="xc-row program-wrap">
        <div class="program-info xc-col">
          <div class="xc-card">
            <div class="xc-card-header">
              <div class="xc-card-title">节目基本信息</div>
            </div>
            <div class="xc-card-content">
              <p>节目名称：{{ programInfo.programName }}</p>
              <p>
                投放级别：{{
                  programInfo.putinLevelName == 1 ? "普通计划" : "插播计划"
                }}
              </p>
              <!-- <p>终端类型：{{programInfo.deviceType}}</p> -->
              <p>终端分辨率：{{ programInfo.deviceResolution }}</p>
              <p>投放开始时间：{{ programInfo.putinStartTime }}</p>
              <p>投放结束时间：{{ programInfo.putinEndTime }}</p>
              <!-- <p>节目基本信息</p> -->
              <p>
                投放周期：
                <span
                  v-for="(item, index) in programInfo.putinLimit"
                  :key="index"
                >
                  <span v-if="item == 0">周一&nbsp;</span>
                  <span v-if="item == 1">周二&nbsp;</span>
                  <span v-if="item == 2">周三&nbsp;</span>
                  <span v-if="item == 3">周四&nbsp;</span>
                  <span v-if="item == 4">周五&nbsp;</span>
                  <span v-if="item == 5">周六&nbsp;</span>
                  <span v-if="item == 6">周日</span>
                </span>
              </p>
              <template v-if="programInfo.programVersion">
                <div class="line"></div>
                <p>创建人：{{ programInfo.addUserName }}</p>
                <p>创建时间：{{ programInfo.addTime }}</p>
                <p>最后操作时间：{{ programInfo.updateTime }}</p>
              </template>
            </div>
          </div>
        </div>
        <div class="program-preview xc-col">
          <div class="xc-card">
            <div class="xc-card-header">
              <div class="xc-card-title">预览区（{{ resolution }}）</div>
            </div>
            <div class="xc-card-content">
              <div class="device device-1080">
                <div class="device-content">
                  <template v-if="currentProgram">
                    <template v-if="currentProgram.fileType == 'image'">
                      <div class="module-preview-item">
                        <div class="cover">
                          <img :src="currentProgram.url" />
                        </div>
                      </div>
                    </template>
                    <template v-else-if="currentProgram.fileType == 'video'">
                      <div class="module-preview-item">
                        <div class="cover">
                          <img :src="currentProgram.fileImageUrl" />
                        </div>
                        <!-- <div class="video-play-icon"></div> -->
                        <video
                          :src="
                            currentProgram.url +
                            '?playIndex=' +
                            currentProgram.playIndex
                          "
                          preload
                          controls
                          autoplay
                        ></video>
                      </div>
                    </template>
                    <template v-else-if="currentProgram.fileType == 'web'">
                      <div class="module-preview-item">
                        <div class="iframe">
                          <iframe
                            :src="currentProgram.url"
                            frameborder="0"
                          ></iframe>
                        </div>
                      </div>
                    </template>
                    <template v-else-if="currentProgram.fileType == 'audio'">
                      <div class="module-preview-item">
                        <div class="iframe">
                          <audio controls ref="audio" class="aud">
                            <source :src="currentProgram.url" />
                          </audio>
                        </div>
                      </div>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="program-data xc-col">
          <div class="xc-card" style="overflow: inherit">
            <div class="xc-card-header">
              <div class="xc-card-title">节目素材页</div>
            </div>
            <div class="xc-card-content">
              <div class="module-add" style="width: 100px; height: 36px">
                <div class="btn-upload btn-upload-video">
                  添加音乐
                  <ul>
                    <li><span @click="upload('audio')">本地上传</span></li>
                    <li><span @click="materialUpload(1)">素材库选择</span></li>
                  </ul>
                </div>
              </div>
              <div class="module-list">
                <template v-if="programJson && programJson.length">
                  <div v-for="(item, key) in programJson" :key="key">
                    <template>
                      <div
                        class="module-item module-item-video"
                        @click="currentModuleIndex = key"
                        :class="{
                          'module-item-active': currentModuleIndex == key,
                        }"
                      >
                        <div class="cover">
                          <img :src="item.fileImageUrl" />
                        </div>
                        <div class="info">
                          <span class="module-name"
                            >节目名称：{{ item.fileName }}</span
                          >
                          <span class="module-duration"
                            >节目时长：{{ item.duration / 1000 }}s</span
                          >
                        </div>
                        <div class="btn-del" @click="deleteModule(key)"></div>
                        <div class="video-play-icon"></div>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="module-item module-item-null">
                    <div class="icon">
                      <img src="@/assets/icon-null.png" />
                    </div>
                    <div class="tips">
                      暂无素材内容，点击上方按钮添加素材内容
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="xc-page-footer">
      <div class="xc-btn-group">
        <div class="xc-btn xc-btn-default" @click="back">上一步</div>
        <!-- <template v-if="index >= deviceResolution.length - 1"> -->
        <template>
          <div class="xc-btn xc-btn-primary" @click="save">保存</div>
          <div class="xc-btn xc-btn-primary" @click="selectPoint">
            保存并选点
          </div>
        </template>
        <!-- <template v-else>
          <div class="xc-btn xc-btn-primary" @click="next">下一步</div>
        </template> -->
      </div>
    </div>
  </div>
</template>
  
  <script>
import myLayerImport from "@/libs/myLayer";
myLayerImport();

import programApi from "@/api/program";

export default {
  name: "programEditor",
  data() {
    return {
      // 节目
      programInfo: {},
      // 节目JSON
      json: {},
      resolution: null,
      deviceResolution: null,

      adminPath: this.$config.adminPath,

      // 节目index
      index: this.$route.query.index || 0,

      // 节目JSON
      programJson: {},

      // 当前所选模块
      currentModuleIndex: null,
    };
  },
  created() {
    this.programInfo = JSON.parse(localStorage.programInfo);

    if (typeof this.programInfo.sourceJson == "string") {
      this.programInfo.sourceJson = JSON.parse(this.programInfo.sourceJson);
    }

    this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      this.currentModuleIndex = null;

      // this.deviceResolution = this.programInfo.deviceResolution.split(",");
      this.deviceResolution = "not";

      this.resolution = "";
      this.programJson = this.programInfo.sourceJson[this.resolution] || [];
    },
    layer(options) {
      layer.open({
        type: 2,
        title: false,
        closeBtn: 0,
        area: ["672px", "379px"],
        shadeClose: true,
        ...options,
      });
    },
    upload(type) {
      this.layer({
        content: this.adminPath + "/material/upload/audio?channel=0",
        success: () => {
          window.audioUploadSubmit = (data) => {
            this.programJson = this.programJson.concat(data);
          };
        },
      });
    },
    //从素材库上传
    materialUpload: function (type) {
      this.layer({
        area: ["1000px", "550px"],
        content: this.adminPath + "/material/select?fileType=audio",
        success: () => {
          window.audioUploadSubmit = (data) => {
            this.programJson.push(data);
          };
        },
      });
    },
    // 上一步
    back() {
      const index = this.index;

      // 当前为第一步
      if (index == 0) {
        // 已保存的节目
        if (this.programInfo.programVersion) {
          this.$router.push(
            this.adminPath + "/program/" + this.programInfo.programVersion
          );
        }
        // 未保存的节目
        else {
          // this.$router.go(-1);
          this.$router.push(this.adminPath + "/program/add?localStorage=1");
        }
      }
      // 上一步返回对应的分辨率
      else {
        this.index = this.index - 1;
        this.$router.push(
          this.adminPath + `/program/add/editor?index=${this.index}`
        );
      }

      this.programInfo.sourceJson.audio = this.programJson;
      localStorage.programInfo = JSON.stringify(this.programInfo);
      this.initData();
    },
    // 下一步预览
    next() {
      this.programInfo.sourceJson.audio = this.programJson;

      this.index = this.index + 1;
      this.$router.push(
        this.adminPath + `/program/add/editor?index=${this.index}`
      );

      // 保存节目信息到本地
      this.saveLocalProgramInfo();

      this.initData();
    },
    // 保存(暂存)
    save() {
      this.programInfo.sourceJson.NOT = this.programJson;

      const data = {
        ...this.programInfo,
        sourceJson: JSON.stringify(this.programInfo.sourceJson),
        checkPointer: false,
        checkSource: false,
        programModel: "audio",
        deviceResolution: "NOT",
      };

      programApi.saveProgram(data).then((v) => {
        this.programInfo.programVersion = v.data;

        // 删除本地缓存
        localStorage.removeItem("programInfo");

        if (parent.layer) {
          parent.layer.close(parent.layer.getFrameIndex(window.name));
          if (parent.initData) parent.initData();
        } else {
          this.$router.replace(this.adminPath + `/program`);
        }
      });
    },
    // 保存并选点(需验证json)
    selectPoint() {
      this.programInfo.sourceJson.NOT = this.programJson;

      const data = {
        ...this.programInfo,
        sourceJson: JSON.stringify(this.programInfo.sourceJson),
        checkPointer: false,
        checkSource: true,
        programModel: "audio",
        deviceResolution: "NOT",
      };

      programApi.saveProgram(data).then((v) => {
        this.programInfo.programVersion = v.data;

        // 保存成功清空本地数据
        localStorage.removeItem("programInfo");

        this.$router.push(
          this.adminPath +
            `/program/${this.programInfo.programVersion}/select-point1`
        );
      });
    },
    // 保存节目信息到本地
    saveLocalProgramInfo() {
      localStorage.programInfo = JSON.stringify(this.programInfo);
    },

    // 删除模块
    deleteModule(index) {
      this.programJson.splice(index, 1);
    },
  },

  computed: {
    // 当前节目
    currentProgram() {
      if (this.programJson && this.programJson.length) {
        if (
          this.currentModuleIndex == undefined ||
          this.programJson.length == 1
        ) {
          this.currentModuleIndex = 0;
          return this.programJson[0];
        } else {
          return this.programJson[this.currentModuleIndex];
        }
      } else {
        return null;
      }
    },
    // 屏幕类型 0、横屏 1、竖屏
    deviceType() {
      if (this.resolution) {
        const array = this.resolution.split("x");

        if (Number(array[0]) >= Number(array[1])) {
          return 0;
        } else {
          return 1;
        }
      } else {
        return -1;
      }
    },

    //判断是否音乐
    isImageOrVideo() {
      if (this.programJson && this.programJson.length) {
        return this.programJson.some((v) => {
          return v.fileType == "audio";
        });
      } else {
        return false;
      }
    },
  },
};
</script>
  
  <style scoped lang="scss">
@import "../scss/_program-json.scss";

.module-item {
  cursor: pointer;
}
</style>
  